import { useEffect, useState } from "react";
import ComponentCard from "../../../components/common/ComponentCard";
import Button from "../../../components/ui/button/Button";
import Label from "../../../components/form/Label";
import Input from "../../../components/form/input/InputField";
import Form from "../../../components/form/Form";
import Select from "../../../components/form/Select";
import { useLocation, useNavigate } from "react-router";

const apiUrl = process.env.REACT_APP_API_URL;

export default function UpdateInspectionItem() {
  const token = localStorage.getItem("token");
  const [headings, setHeadings] = useState<any[]>([]);
  const navigate = useNavigate();
  const location = useLocation();
  const inspectionItem = location.state?.inspectionItem;

   const [formData, setFormData] = useState({
    inspectiontask_id: "",
    inspectionitemname: "",
    headingid: "",
    status: "",
    details: "",
  });

  const [errors, setErrors] = useState({
    inspectionitemname: "",
    headingname: "",
    status: "",
    details: "",
  });

  useEffect(() => {
    if (inspectionItem) {
      setFormData({
      inspectiontask_id: inspectionItem.inspectiontask_id || "",
      inspectionitemname: inspectionItem.inspectionitem_name || "",
      headingid: inspectionItem.inspectiontaskheading_id || "",
      status: inspectionItem.status === 1 ? "Current" : "Non-Current",
      details: inspectionItem.remarks || "",
      });
    }
  } , [inspectionItem]);

  const fetchHeadings = async () => {
    try {
      const response = await fetch(`${apiUrl}/inspection_items/headings`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          token: token || "",
        },
      });
      const result = await response.json();
      
      if (result.success) {
        setHeadings(result.headings);
      }
    } catch (err) {
      console.error("Error fetching headings:", err);
      setHeadings([]);
    }
  };
  
  useEffect(() => {
    fetchHeadings();
  }, []);

  //Handle text input changes
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setErrors({
      ...errors,
      [e.target.name]: "",
    });
  };

  // Handle select dropdowns
  const handleSelectStatus = (option:any) => {
    
    setFormData({
      ...formData,
      status: option,
      
    });
    setErrors({
      ...errors,
      status: "",
    });
  };

  const handleSelectHeading = (option: any) => {
    console.log("Selected heading option:", option);
    
    setFormData({
      ...formData,
      headingid: option,
    });
    setErrors({
      ...errors,
      headingname: "",
    });
  };

  // ✅ Handle submit
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    // if (!validate()) return;
    try {
      const payload = {
        inspectiontask_id: formData.inspectiontask_id,
        inspectionitemname: formData.inspectionitemname,
        headingid: formData.headingid,
        status: formData.status,
        details: formData.details,
      };
      const response = await fetch(`${apiUrl}/inspection_items`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          token: token || "",
        },
        body: JSON.stringify(payload),
      });
      if (response.ok) {
        navigate("/inspection-items");
      }
    } catch (err) {
      console.error("Error:", err);
    }
    
  };

  const handleCancel = () => {
    navigate("/inspection-items");
  };

  const handleDelete = async () => {
    if (!window.confirm("Are you sure you want to delete this inspection-items?")) return;

    try {
      const token = localStorage.getItem("token");

      const response = await fetch(
        `${apiUrl}/inspection_items/${inspectionItem.inspectiontask_id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            token: token || "",
          },
        }
      );

      if (response.ok) {
        navigate("/inspection-items");
      }
    } catch (err) {
      console.error("Delete Error:", err);
    }
  };

  return (
    <ComponentCard title="Add New Inspection Item">
      <Form onSubmit={handleSubmit}>
        <div className="grid gap-6">
          <div className="col-span-full">
            <h4 className="pb-4 text-base font-medium text-gray-800 border-b border-gray-200 dark:border-gray-800 dark:text-white/90">
              Inspection Item Details
            </h4>
          </div>

          {/* Inspection Item Name */}
          <div>
            <Label>Inspection Item Name</Label>
            <Input
              type="text"
              name="inspectionitemname"
              value={formData.inspectionitemname}
              onChange={handleChange}
            />
            {errors.inspectionitemname && (
              <p className="text-red-500 text-sm">{errors.inspectionitemname}</p>
            )}
          </div>

          {/* Heading */}
          <div>
            <Label>Heading</Label>
            <Select
              options={headings.map(heading => ({
                key: heading.inspectiontaskheading_id,
                value: heading.inspectiontaskheading_id,
                label: heading.name,
              }))}
              value={formData.headingid}
              onChange={handleSelectHeading}
              className="mt-2 bg-gray-50 dark:bg-gray-800"
            />

            {errors.headingname && (
              <p className="text-red-500 text-sm">{errors.headingname}</p>
            )}
          </div>

          {/* Status */}
          <div>
            <Label>Status</Label>
            <Select
              options={[
                { value: "Current", label: "Current" },
                { value: "Non-Current", label: "Non-Current" },
              ]}
              value={formData.status}
              onChange={handleSelectStatus}
              className="mt-2 bg-gray-50 dark:bg-gray-800"
            />
            {errors.status && (
              <p className="text-red-500 text-sm">{errors.status}</p>
            )}
          </div>

          {/* Details */}
          <div>
            <Label>Details</Label>
            <textarea
              className="w-full rounded-lg border px-4 py-2.5 text-sm shadow-theme-xs focus:outline-none text-gray-600 border-gray-300 focus:border-brand-300 focus:ring focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:focus:border-brand-800"
              name="details"
              onChange={handleChange}
              value={formData.details}
            />
            {errors.details && (
              <p className="text-red-500 text-sm">{errors.details}</p>
            )}
          </div>

          {/* Buttons */}
          <div className="flex gap-3">
            <Button size="sm" type="submit">
              Save Changes
            </Button>
            <Button size="sm" variant="outline" type="button" onClick={handleCancel}>
              Cancel
            </Button>
            <button className="px-4 py-3 text-sm font-medium text-white rounded-lg bg-error-800 shadow-theme-xs hover:bg-error-600" onClick={handleDelete}>
							Delete
						</button>
          </div>
        </div>
      </Form>
    </ComponentCard>
  );
}
